// extracted by mini-css-extract-plugin
export default {"Switch":"styles_Switch__0Br35","Switch--selected":"styles_Switch--selected__NZoGM","Switch--disabled":"styles_Switch--disabled__Od-sD"};